/**
 *  Valid data attributes for the template data.
 */
export enum DataAttributes {
  Fullstory = 'fullstory',
  Test = 'test',
  DynamicYield = 'dynamic-yield'
}
